var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFintechIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.001,
    height: 34,
    viewBox: "0 0 34.001 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fintech",
    transform: "translate(-0.001 -0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999",
    transform: "translate(0.001 15.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3126",
    "data-name": "Path 3126",
    d: "M.464,239.007a.708.708,0,0,0-.421.907l.445,1.224,3.387-3.387Z",
    transform: "translate(-0.001 -237.75)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(3.67 27.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3127",
    "data-name": "Path 3127",
    d: "M55.257,420.513l2.04,5.61a.7.7,0,0,0,.367.4.713.713,0,0,0,.3.067.693.693,0,0,0,.245-.044l2.251-.83Z",
    transform: "translate(-55.257 -420.513)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003",
    transform: "translate(18.912 16.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3128",
    "data-name": "Path 3128",
    d: "M299.829,258.143l-2.335-6.419-5.6,5.6,2.777-1.023a.708.708,0,1,1,.49,1.329l-3.527,1.3a.708.708,0,0,1-.91-.419s0-.009,0-.013l-5.937,5.937,14.626-5.389A.706.706,0,0,0,299.829,258.143Z",
    transform: "translate(-284.783 -251.724)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(0.002 0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3129",
    "data-name": "Path 3129",
    d: "M33.811,11.546,22.478.213a.709.709,0,0,0-1,0L.226,21.463a.709.709,0,0,0,0,1L11.559,33.8a.7.7,0,0,0,.5.208.711.711,0,0,0,.5-.207l21.25-21.25A.711.711,0,0,0,33.811,11.546Zm-25.5,8.086L5.478,22.466a.709.709,0,0,1-1-1l2.833-2.833a.709.709,0,0,1,1,1Zm12.233.9a2.674,2.674,0,0,1-1.941.742,5.853,5.853,0,0,1-3.94-1.881,6.49,6.49,0,0,1-1.769-3.015,2.96,2.96,0,0,1,.63-2.866,2.951,2.951,0,0,1,2.866-.63A6.478,6.478,0,0,1,19.4,14.652C21.373,16.618,21.874,19.2,20.544,20.532Zm9.017-7.983-2.833,2.833a.709.709,0,1,1-1-1l2.833-2.833a.709.709,0,0,1,1,1Z",
    transform: "translate(-0.019 -0.006)",
    fill: "#7dbaab"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFintechIcon);
export default __webpack_public_path__ + "static/media/fintech-icon.2616474d58815abb9e2cba73b12f0b3f.svg";
export { ForwardRef as ReactComponent };